import { Controller } from "@hotwired/stimulus"
import { computePosition, shift, offset, flip, autoUpdate } from "@floating-ui/dom"

export default class extends Controller {
    static targets = ['tooltip']
    static values = {
        position: String
    }

    connect() {
        this.cleanup = null
    }

    show(e) {
        const reference = this.element
        const tooltip = this.tooltipTarget

        tooltip.hidden = false

        this.cleanup = autoUpdate(reference, tooltip, () => {
            computePosition(reference, tooltip, {
                placement: (this.positionValue || "top"),
                middleware: [offset(8), flip(), shift()]
            }).then(({ x, y }) => {
                Object.assign(tooltip.style, {
                    left: `${x}px`,
                    top: `${y}px`,

                })
            })
        })
    }

    hide() {
        this.tooltipTarget.hidden = true;
        if (this.cleanup) {
            this.cleanup()
            this.cleanup = null
        }
    }
}
